export function spaceDims(scale, xInt, yInt, height, width){
    let nx = scale/xInt
    let ny = scale/yInt
    //let ny = (height/width)*scale/yInt

    //espaçamento entre as linhas
    let sx = width/nx
    let sy = width/ny

    return {
        nx,
        ny,
        sx,
        sy
    }
}